import { c as _c } from "react/compiler-runtime";
import { BACKGROUND_TASK_STATES } from "@api/progress-api/progress-api-constants";
import { SphereNotificationPopover } from "@components/common/sphere-notification-popover";
import { Box } from "@mui-wrapper";
import { FontWeights } from "@flat-ui";
import { UiUtils } from "@stellar/utils";
import { PALETTE_VARS } from "@styles/palette-vars";

/** Renders the status of the background tasks */
export function BackgroundTaskStatus(t0) {
  const $ = _c(11);
  const {
    task
  } = t0;
  let fontColor;
  const status = task.state ?? UiUtils.DASH;
  const message = task.message;
  bb0: switch (status) {
    case BACKGROUND_TASK_STATES.Created:
    case BACKGROUND_TASK_STATES.Scheduled:
      {
        fontColor = PALETTE_VARS.text.primary;
        break bb0;
      }
    case BACKGROUND_TASK_STATES.Started:
      {
        fontColor = PALETTE_VARS.primary.dark;
        break bb0;
      }
    case BACKGROUND_TASK_STATES.Succeeded:
      {
        fontColor = PALETTE_VARS.success.main;
        break bb0;
      }
    case BACKGROUND_TASK_STATES.Aborted:
      {
        fontColor = PALETTE_VARS.warning.main;
        break bb0;
      }
    case BACKGROUND_TASK_STATES.Failed:
      {
        fontColor = PALETTE_VARS.error.main;
        break bb0;
      }
    default:
      {
        fontColor = PALETTE_VARS.text.primary;
      }
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      display: "flex",
      alignItems: "center"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== fontColor) {
    t2 = {
      color: fontColor,
      fontWeight: FontWeights.SemiBold
    };
    $[1] = fontColor;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== status || $[4] !== t2) {
    t3 = <Box component="div" sx={t2}>{status}</Box>;
    $[3] = status;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== message) {
    t4 = message && <SphereNotificationPopover message={message} sx={{
      marginLeft: "10px"
    }} />;
    $[6] = message;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3 || $[9] !== t4) {
    t5 = <Box component="div" sx={t1}>{t3}{t4}</Box>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}